import { inject, Injectable } from "@angular/core";
import { GoogleAddressDto, GooglePlaceListItemDto } from "@dtos/googlePlace";
import { TransportAddress, TransportAddressListResponse } from "@dtos/transports/transport-address.dto";
import { ApiService } from "@services/api.service";
import { EndPoints } from "@services/EndPoints";

export interface AddressListParams {
  page?: number;
  page_size?: number;
  search?: string;
  address_type?: string;
  client_id?: number;
  client_user?: number;
  subentity_id?: number;
  contact_name?: string;
  contact_email?: string;
  contact_phone?: string;
  is_active?: boolean;
  [key: string]: any;
}

@Injectable({ providedIn: 'root' })
export class AddressProvider {
  private readonly api = inject(ApiService);

  async loadAddresses(params: AddressListParams): Promise<{ list: TransportAddress[], totalRecords: number } | null> {
    try {
      params.page = params.page || 1;
      params.page_size = params.page_size || 50;

      // Limpiar parámetros vacíos
      const cleanParams: any = {};
      Object.keys(params).forEach(key => {
        const value = params[key];
        // Para boolean, incluir incluso si es false
        if (typeof value === 'boolean') {
          cleanParams[key] = value;
        } else if (value !== undefined && value !== null && value !== '') {
          cleanParams[key] = value;
        }
      });

      const result: TransportAddressListResponse = await this.api.get<TransportAddressListResponse>({
        url: EndPoints.getTransportAddresses,
        queryParams: cleanParams
      });

      return {
        list: result.results || [],
        totalRecords: result.count || 0
      };
    } catch (error) {
      console.error('Error al cargar direcciones:', error);
      return null;
    }
  }

  async getAddress(id: number | string): Promise<TransportAddress | null> {
    try {
      const url = EndPoints.getTransportAddress.replace("{addressId}", id.toString());
      return await this.api.get<TransportAddress>({ url });
    } catch (error) {
      console.error('Error al obtener dirección:', error);
      return null;
    }
  }

  async createAddress(address: Partial<TransportAddress>): Promise<TransportAddress | null> {
    try {
      return await this.api.post<TransportAddress>({
        url: EndPoints.createTransportAddress,
        body: address
      });
    } catch (error) {
      throw error;
    }
  }

  async updateAddress(id: number, address: Partial<TransportAddress>): Promise<TransportAddress | null> {
    try {
      const url = EndPoints.updateTransportAddress.replace("{addressId}", id.toString());
      return await this.api.patch<TransportAddress>({
        url,
        body: address
      });
    } catch (error) {
      throw error;
    }
  }
  async addressByGoogle(query: string): Promise<GooglePlaceListItemDto[]> {
    try {
      return (await this.api.get<GooglePlaceListItemDto[]>({ url: EndPoints.addressByGoogle.replace("{query}", query) }));

    } catch (error) {
      console.error('Error al obtener transporte:', error);
      return [];
    }
  }
  async addressByPlaceId(placeId: string): Promise<GoogleAddressDto | null> {
    try {
      return (await this.api.get<GoogleAddressDto>({ url: EndPoints.addressByPlaceId.replace("{google_id}", placeId) }));

    } catch (error) {
      console.error('Error al obtener transporte:', error);
      return null;
    }
  }
  async deleteAddress(addressId: number): Promise<boolean> {
    try {
      await this.api.delete<any>({ url: EndPoints.deleteTransportAddress.replace("{addressId}", addressId.toString()) });
      return true;
    } catch (error) {
      console.error('Error al obtener transporte:', error);
      throw error;
    }
  }
  async getAddressesByIds(ids: number[]): Promise<TransportAddress[] | null> {
    try {
      return (await this.api.post<TransportAddress[]>({ url: EndPoints.getTransportAddressesByIds, body: { address_ids: ids } }));
    } catch (error) {
      console.error('Error al obtener transporte:', error);
      return null;
    }
  }

}

